<template>
  <div id="app">
    <div v-show="env != 'production'" style="position: fixed; left: 0; top: 0">
      <span
        style="
          position: absolute;
          left: 0;
          top: 0;
          padding: 5px;
          background: gray;
          color: white;
          border: 1px solid black;
        "
        @click="reload()"
        >{{ env }}
      </span>
    </div>
    <div v-if="!customer" class="fulscreen-loading">
      <div class="logo" style="margin-top: -200px"></div>
      <div class="el-loading-spinner" style="margin-top: -10px">
        <svg viewBox="25 25 50 50" class="circular">
          <circle cx="50" cy="50" r="20" fill="none" class="path" />
        </svg>
        <!---->
      </div>
    </div>
    <router-view v-if="customer" />
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "App",
  async created() {
    this.loadCustomer();
    const recaptcha = this.$recaptchaInstance;

    // Hide reCAPTCHA badge:
    if(recaptcha){

      await recaptcha.hideBadge();
    }
  },
  computed: {
    customer() {
      return this.$store.state.account.customer;
    },
    env() {
      return process.env.NODE_ENV;
    },
  },
  methods: {
    reload() {
      document.location.reload(true);
    },
    ...mapActions("account", ["loadCustomer"]),
  },
};
</script>
<style>
.bordered{
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding:10px 0;
  margin-left:10px;
  margin-top:10px;
}
.modebar-btn--logo{
display: none;
}
.grecaptcha-badge {
    display: none !important;
}
.fulscreen-loading {
  height: 100%;
  display: flex;
  align-items: center;
  width: 100%;
  background-color: #ececec;
  position: absolute;
  top: 0;
  align-content: stretch;
  z-index: 10006;
  flex-direction: column;
  left: 0;
}
.fulscreen-loading .logo {
  background-image: url(/images/logo.png);
  width: 24%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  flex: 1;
}
@media only screen and (max-width: 1024px) {
  .fulscreen-loading .logo {
    width: 54%;
  }
}
#app {
  font-family: Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0;
}

*::-webkit-scrollbar-track {
  background-color: #f5f5f5;
  border-radius: 10px;
}

*::-webkit-scrollbar {
  width: 8px;
  background-color: #f5f5f5;
}

*::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: #c1c1c1;
}
</style>
